import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-logo-svg',
	templateUrl: './logo-svg.html',
	styleUrls: ['./logo-svg.scss']
})

export class LogoSVGComponent {
	@Input() public white = false;
	@Input() public black = false;

	constructor() {
	}
}
